import { Suspense } from "react";
import Loading from "../../components/ui/Loading/Loading";
import { ErrorBoundary } from "../errorBoundary/ErrorBoundary";

export function SuspenseWithErrorBoundary(props) {
  const { pendingProps, ...errorBoundaryProps } = props;

  return (
    <ErrorBoundary {...errorBoundaryProps}>
      <Suspense fallback={<Loading />}>{props.children}</Suspense>
    </ErrorBoundary>
  );
}
